$('.menu-toggler').on('click', function() {
    $(this).toggleClass('menu-toggler--opened');
    $('body').toggleClass('main-menu--opened');
});